module.exports = __webpack_public_path__ + "static/media/img-2.55d3bb3b.jpg";